import { useNavigate } from 'react-router';
import { Button } from '../../components/Common';

const PageNotFound = (): JSX.Element => {
    const navigate = useNavigate();
    return (
        <div className="page-not-found">
            <img className="page-not-found__logo" src="/svg/blue-logo.svg" alt="blue fornulio logo" />
            <img className="page-not-found__404-image" src="/svg/404-error.svg" alt="404 error" />
            <h1 className="page-not-found__title">Page not found</h1>
            <p className="paragraph-3 page-not-found__text">Sorry, we couldn't find the page you were looking for.</p>
            <Button className="page-not-found__button" text="Go to Homepage" onClick={() => navigate('/')}></Button>
        </div>
    );
};

export default PageNotFound;
